import React from "react";
import { LayoutGrid, Swords, TrendingDown, TrendingUp, Zap } from "lucide-react";
import { MARKET_TYPES } from "../../../utils/bondPredictHelpers";

const marketTypeIcon = (type) => {
  if (type === MARKET_TYPES.HEAD_TO_HEAD) return Swords;
  if (type === MARKET_TYPES.MULTI_BINARY) return LayoutGrid;
  return Zap;
};

/** Market-type glyph for holdings rows (not a user avatar). */
export const PortfolioMarketTypeSign = ({ market, statusTone = "muted" }) => {
  const type = market?.type || MARKET_TYPES.BINARY;
  const Icon = marketTypeIcon(type);
  return (
    <span
      className={`bp-port-item-sign bp-port-item-sign-market bp-port-item-sign-status-${statusTone}`}
      aria-hidden
    >
      <Icon size={13} strokeWidth={2.3} />
    </span>
  );
};

/** Buy/sell direction glyph for order rows. */
export const PortfolioOrderSideSign = ({ side }) => {
  const s = String(side || "").toUpperCase();
  const isSell = s === "SELL";
  const Icon = isSell ? TrendingDown : TrendingUp;
  const tone = isSell ? "sell" : s === "BUY" ? "buy" : "neutral";
  return (
    <span className={`bp-port-item-sign bp-port-item-sign-order bp-port-item-sign-side-${tone}`} aria-hidden>
      <Icon size={13} strokeWidth={2.4} />
    </span>
  );
};
